import Tray from "@/components/Tray.vue";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
    
export type TrayType =
  | 'toolsTable'
  | 'staff'
  | 'device'
  | 'bed'
  | 'deviceColumn'
  | 'patient'
  | 'operationTable'
  | 'tableAccessory'
  | 'patientAccessory'
  | 'otherInformation'
  | 'images'
  | null; // Allow null as a valid type

@Module({ namespaced: true })
class TrayModule extends VuexModule {
  openTray: TrayType = null;

  @Mutation
  private SET_OPEN_TRAY(tray: TrayType) {
    this.openTray = tray;
  }

  @Action
  public toggleTray(tray: TrayType) {
    if (this.openTray === tray) {
      this.context.commit("SET_OPEN_TRAY", null);
    } else {
      this.context.commit("SET_OPEN_TRAY", tray);
    }
  }

  @Action
  closeTray() {
    this.context.commit("SET_OPEN_TRAY", null);
  }

  get isTrayOpen(): (tray: TrayType) => boolean {
    return (tray: TrayType) => this.openTray === tray;
  }
}

export default TrayModule;
